/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Тип резюме
 */
export enum ResumeType {
    FILE = 'file',
    URL = 'url',
}
